export const FILES = 'FILES';
export const FILE = 'FILE';
export const DELETE = 'DELETE';
export const SORT = 'SORT';
export const MORE = 'MORE';
export const LOADING = 'LOADING';
export const TOTAL = 'TOTAL';
export const CLEAR_ITEMS = 'CLEAR_ITEMS';
export const RESET_FILTER = 'RESET_FILTER';
export const SET_CLUSTER_OUTFITS = 'SET_CLUSTER_OUTFITS';
export const RESET_CLUSTERS_ITEMS = 'RESET_CLUSTERS_ITEMS';
export const SET_CLUSTERS = 'SET_CLUSTERS';
export const SET_CLUSTERS_LOADING = 'SET_CLUSTERS_LOADING';
export const RESET_LOGS_ITEMS = 'RESET_LOGS_ITEMS';
export const SET_LOGS = 'SET_LOGS';
export const SET_LOGS_LOADING = 'SET_LOGS_LOADING';
export const SET_POSSIBLE_FPS = 'SET_POSSIBLE_FPS';

export default {
  FILES,
  FILE,
  DELETE,
  SORT,
  MORE,
  LOADING,
  TOTAL,
  CLEAR_ITEMS,
  RESET_FILTER,
  SET_CLUSTER_OUTFITS,
  RESET_CLUSTERS_ITEMS,
  SET_CLUSTERS,
  SET_CLUSTERS_LOADING,
  RESET_LOGS_ITEMS,
  SET_LOGS,
  SET_LOGS_LOADING,
  SET_POSSIBLE_FPS,
};
